import { EmptyPhoneNumber } from "@/constants";
import { z } from "@utils/zod";

import type { IPhoneNumber } from "@interfaces";
import type { IShapeOfField } from "@utils/zod";

export interface IForgetPasswordFormSchema {
  phone: IPhoneNumber;
}

export const forgetPasswordFormInitialValues: IForgetPasswordFormSchema = {
  phone: EmptyPhoneNumber,
};

export const forgetPasswordFormValidationSchema = z.object<
  IShapeOfField<IForgetPasswordFormSchema>
>({
  phone: z.phone(),
});
